var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v(_vm._s(_vm.actionStyling[_vm.action._type].description)+" '"+_vm._s(_vm.action.label.substring(0, 35))+"'")])}
var staticRenderFns = []

export { render, staticRenderFns }